import {Notifier} from "@intermesh/goui";
import {CurrentItem} from "./CurrentItem.js";
import {t} from "../util/Translate.js";
import {frontendCourseDS} from "../DataSources";

export class CurrentCourse extends CurrentItem {
	static storageItem = "currentCourse";
	static baseRoute = "elearning/frontend/courses";
	static returnProperties = "*,languages[*,language], blocks[*,block[*,languages[*,content,language]]],sections[*]";

	static async readIf(identifier: string) {
		const id = identifier;
		let s = JSON.parse(sessionStorage.getItem(CurrentCourse.storageItem)!);

		if (!s || s.id != id) {
			try {
				const course = await frontendCourseDS.single(id);

				if (course) {
					sessionStorage.setItem(CurrentCourse.storageItem, JSON.stringify(course));
				}
			} catch (err) {
				Notifier.error(err, 3000);
			}
		}
		return CurrentCourse.get();

	}

	static async load(id: string) {
		CurrentCourse.reset();

		const course = await frontendCourseDS.single(id);
		if (course) {
			sessionStorage.setItem(CurrentCourse.storageItem, JSON.stringify(course));
			return CurrentCourse.get();
		}
		throw t("Course not found");
	}

	static get() {
		return JSON.parse(sessionStorage.getItem(CurrentCourse.storageItem)!);
	}

	static reset() {
		sessionStorage.removeItem(CurrentCourse.storageItem);
	}
}

export const currentCourse = () => Object.assign(new CurrentCourse());